import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppConstant } from '@app/shared/constants';
import { LoginSignUpModel } from '@app/core/models/loginsignupmodel';
import { W9SFormModel } from '@app/core/models/W9SFormModel';
import { environment } from '@env/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SignUpService {
  str: any [] = [];
  constructor(private http: HttpClient, private router: Router) { }

  createSignUp(signup: LoginSignUpModel) {
    return this.http.post(environment.baseUrl + AppConstant.SIGNUP, signup);
  };

  AddW9SDetails(w9SModel: W9SFormModel){
    return this.http.post(environment.baseUrl + AppConstant.ADDW9SFormDetails, w9SModel);
  };

  CheckUserExist(email: string) {
    return this.http.get(environment.baseUrl + AppConstant.CheckDuplicateEmail + "?email=" + email);
  };
  subscribeNewsletter(subscribeFormDetails: any) {
    return this.http.post(environment.baseUrl + AppConstant.SubscribeNewsletter,subscribeFormDetails);
  }

  CheckTokenExpiry(token: string) {
    return this.http.get(environment.baseUrl + AppConstant.CHECK_INVITATION_TOKEN + "?token=" + encodeURIComponent(token));
  };
  AcceptInvitation(email: string){
    return this.http.get(environment.baseUrl + AppConstant.ACCEPT_INVITATION + "?email=" + email);
  }
}
